export default "__VITE_ASSET__ByuETiH9__"